import { render, staticRenderFns } from "./VoucherCreate.vue?vue&type=template&id=28d6a58a&scoped=true&"
import script from "./VoucherCreate.vue?vue&type=script&lang=js&"
export * from "./VoucherCreate.vue?vue&type=script&lang=js&"
import style0 from "./VoucherCreate.vue?vue&type=style&index=0&id=28d6a58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d6a58a",
  null
  
)

export default component.exports